import { useState, useRef,useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {Row, Col, Form, Select, Input, Flex, Typography,
        Button, Upload, message, 
        Spin,
        Card,
        Space} from 'antd';
import { ArrowLeftOutlined, 
        EditOutlined, 
        SaveOutlined, 
        UploadOutlined} from '@ant-design/icons'
import Phone from "../../Components/Phone";
import styles from './Consultant.module.css'
import api from "../../API";
const { TextArea } = Input;

const options = [
    {
    value: 'text',
    label: 'Tư vấn dạng văn bản',
    },
    {
    value: 'image',
    label: 'Tư vấn dạng hình ảnh',
    },
    {
    value: 'attachment',
    label: 'Tư vấn đính kèm file',
    }
]

function Consultant({tplType}){
    const navigate = useNavigate();
    const location = useLocation();
    const detailInfo = location.state;
    const user = JSON.parse(localStorage.getItem('user'));
    const [form] = Form.useForm();
    const [selectedValue, setSelectedValue] =useState(0);
    const [contentMessage, setContentMessage] = useState('');
    const [uploadFile, setUploadFile] = useState([]);
    const [loading, setLoading] = useState({spin: false, contact: false, templateBtn:false});
    const now = useRef((new Date()).toLocaleString('en-CA').replace(/[,.apm]/g,''));
    const initialValues = {
        templateCode: `Template_Zalo_Follower_${(new Date()).toLocaleString('en-CA').replace(/[-:, .amp]/g,'')}`,
        template_type: 'text',
        template_media_type: '',
        template_text: '',
        template_file: []
    }

    //When edit template
    useEffect(() => {
        if(detailInfo) {
            setLoading({...loading, spin: true});
            let index = options.findIndex(option => (option.value === detailInfo.template_type))
            form.setFieldsValue({
                templateCode: detailInfo.templateCode,
                template_type: detailInfo.template_type,
                template_file: index? [{uid: 'file', ...(JSON.parse(detailInfo.template_file))}]: [],
                template_text: detailInfo.template_text,
                template_media_type: detailInfo.template_media_type,
            });
            setSelectedValue(index);
            setContentMessage(detailInfo.template_text);
            setUploadFile(form.getFieldValue('template_file'));
            now.current = (new Date(detailInfo.createdDate)).toLocaleDateString('en-CA');
            setLoading({...loading, spin: false});
        }
    },[])

    //Clean up image uploadFile
    useEffect(() => {
        return () => {
          uploadFile[0] && URL.revokeObjectURL(uploadFile[0].url); 
        }
    }, [uploadFile[0]])

    function handleSelectedSampleCassification(selectedvalue) {
        var index= options.findIndex(value => (value.value === selectedvalue));
        form.resetFields(['template_file', 'template_text','template_media_type']);
        setUploadFile([]);
        setContentMessage('');
        setSelectedValue(index);
    }

    function handleValueChange(e) {
        setContentMessage(e.target.value)
    }

    function beforeUploadImage(file) {
        return new Promise((resolve, reject) => {
            const isSizeValid = file.size / 1024 / 1024 <= 1;
            if (!isSizeValid) {
                message.error('Image file size must not exceed 1MB!');
                reject(false);
            }
            resolve(true);
        });
    };

    function beforeUploadFile(file) {
        return new Promise((resolve, reject) => {
          const maxFileSize = 5 * 1024 * 1024; // 5MB
          if (file.size > maxFileSize) {
            message.error('File size must not exceed 5MB!');
            reject(false); 
          } else {
            resolve(true); 
          }
        });
    }

    async function customRequestFile({ file, onSuccess, onError }) {
        try {
            let ok = selectedValue === 1;
            if(ok) await beforeUploadImage(file); // Kiểm tra điều kiện trước khi tải lên
            else await beforeUploadFile(file);
            onSuccess('ok');
            if(ok) message.success('Photo uploaded successfully');
            else message.success('File uploaded successfully');
        } catch (error) {
            // Xử lý lỗi từ beforeUploadImage hoặc beforeUploadFile
            onError('err');
        }
    }

    function handleFile({file}) {
        if (file.status === 'done') {
            if(file.type.startsWith('image/')) form.setFieldValue('template_media_type', (file.type.endsWith('gif')? 'gif': 'image'))
            form.setFieldValue('template_file', [{
                uid: file.uid, 
                name: file.name,
                file: file.originFileObj,
                url: URL.createObjectURL(file.originFileObj),
            }]);
            setUploadFile([{
                uid: file.uid, 
                name: file.name,
                file: file.originFileObj,
                url: URL.createObjectURL(file.originFileObj),
            }]);   
        } else if(file.status === 'error') {
            form.setFieldValue('template_file', uploadFile);
        } else return;
    };

    function handleRemoveFile(file) {
        setUploadFile([]);
        return true;
    }

    async function handleSubmit(formValues) {
        let resultUploadImg;
        try{
            setLoading({...loading, templateBtn: true});
            let template_file = '';
            if(selectedValue) {
                if(formValues.template_file[0].file) {
                    resultUploadImg = await api.uploadFiles([formValues.template_file[0].file]);
                    template_file = JSON.stringify(resultUploadImg[0]);
                } else template_file = detailInfo.template_file;
            } 
            const consultantTemplateObj = {
                id: 1,
                ...formValues,
                template_file,
                createdDate: now.current,
                lastUpdated: (new Date()).toLocaleString('en-CA').replace(/[,.apm]/g,''),
                userId: user?.userId
            }
            let response = detailInfo?
                await api.update_templateById(detailInfo.id, consultantTemplateObj, tplType):
                await api.create_new_template(consultantTemplateObj, tplType);
            if((!selectedValue || formValues.template_file[0]?.file) && detailInfo?.template_file) await api.deleteFiles([JSON.parse(detailInfo.template_file).url.split("/").pop()]);
            message.success(response.message);
            navigate('/template/consultants');
        } catch(error) {
            message.error(error.message);
            if(resultUploadImg) api.deleteFiles([resultUploadImg[0]?.url.split("/").pop()]).catch(err => message.error(err.message));
        } finally {
            setLoading({...loading, templateBtn: false})
        }
    };

    return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
        <Space>
            <Link to="/template/consultants">
                <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
            </Link>
            <Typography.Title level={5} style={{margin: 0}}>{detailInfo? 'Update': 'Create new'} consulatant</Typography.Title>
        </Space>
        }
        loading={loading.spin}
    >
        <Form name="consultantform" label="consultant form" layout='vertical' form={form} initialValues={initialValues} onFinish={handleSubmit}>
            <Row gutter={[0,16]}>
                <Col className="gutter-row" xxl={12} xl={12} lg={24} sm={24} xs={24}>
                    <Row className={styles.form}> 
                        <Col span={24}>
                            <Form.Item label='Template Code' 
                                        name='templateCode'  
                                        rules={[
                                        {
                                            required: true,
                                            message: 'The template code cannot be empty'
                                        }
                                        ]}>
                                <Input maxLength={100}/>
                            </Form.Item> 
                            <Form.Item  label='Classify templates' 
                                        name='template_type' 
                                        rules={[
                                        {
                                            required: true,
                                        }]}>
                                <Select onChange={handleSelectedSampleCassification} options={options}/>
                            </Form.Item>            
                            <Form.Item label={selectedValue === 1? 'Image': 'File'}
                                    name='template_file'
                                    valuePropName= 'fileList'
                                    hidden = {selectedValue === 0}
                                    getValueFromEvent= {(e) => {
                                        if (Array.isArray(e)) return e;
                                        return e && e.fileList;
                                    }}
                                    rules={selectedValue === 0 ? []: [{required: true, message: 'The file cannot be empty'}]}
                                    style={{textAlign: 'left'}}>
                                <Upload
                                    name='uploadimagefile'
                                    accept={selectedValue === 1? 'image/jpeg,image/png,image/gif': '.pdf,.doc,.docx'}
                                    customRequest={customRequestFile}
                                    onChange={handleFile}
                                    onRemove={handleRemoveFile}
                                    maxCount={1}>
                                    <Button icon={<UploadOutlined />}>
                                        Click to Upload
                                    </Button>
                                </Upload>
                            </Form.Item>
                            <Form.Item label='Content' 
                                        name='template_text'  
                                        hidden={selectedValue === 2}
                                        rules={selectedValue === 2 ? []: [{required: true, message: 'The content cannot be empty'}]}>
                                <TextArea type='text'
                                        maxLength={1000} 
                                        showCount 
                                        rows={4}
                                        onKeyUp={handleValueChange}/>
                            </Form.Item>
                            <Form.Item hidden  name='template_media_type'>
                                <Input/>
                            </Form.Item> 
                        </Col> 
                    </Row>
                    <Row className={styles.button}>
                        <Col span={24} style={{textAlign: 'left'}}>
                            <Form.Item noStyle>
                                <Button type="primary" htmlType="submit" loading={loading.templateBtn} icon={detailInfo? <EditOutlined/>: <SaveOutlined/>}>
                                    {detailInfo? 'Update Template': 'Save to Draft'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row> 
                </Col>
                <Col className="gutter-row" xxl={12} xl={12} lg={24} sm={24} xs={24}>
                    <Row>
                        <Col span={24}>
                            <div className={styles.title2}>Preview</div>                   
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Phone  
                                phoneProps={{
                                    imageURL: selectedValue === 1 && uploadFile[0]? uploadFile[0].url: null,
                                    msgType:'normal',
                                    textMsg: selectedValue === 0 || selectedValue === 1? contentMessage: null,
                                    fileMsg: selectedValue === 2 && uploadFile[0]
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row> 
        </Form> 
    </Card>);
}

export default Consultant;